import { Ng1StateDeclaration } from '@uirouter/angularjs';

const states: Ng1StateDeclaration[] = [
    {
        template: '<wt-identifiers-management-state></wt-identifiers-management-state>',
        name: 'identifiersManagement',
        url: '/identifiersManagement/:groupGuid?',
        data: {
            visible: false,
            displayName: 'Identifiers management'
        }
    }];

export default states;